<div class="dialog-title">
    Assign Letter Of Offer
</div>

<mat-form-field>
    <mat-label>Select Letter of Offer</mat-label>
    <mat-select multiple>
        <mat-option *ngFor="let letterTemplate of letterTemplates" [value]="letterTemplate.id"
            (onSelectionChange)="selectedLetterTemplate($event)">{{ letterTemplate.name }}
        </mat-option>
    </mat-select>
</mat-form-field>


<div class="dialog-buttons">
    <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
    <button mat-button color="primary"  (click)= "assign()">Save</button>
</div>